"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOUD_NAME = exports.CLOUDINARY_URL = exports.CLOUDINARY_API_KEY = void 0;
var CLOUDINARY_URL = 'https://widget.cloudinary.com/v2.0/global/all.js';
exports.CLOUDINARY_URL = CLOUDINARY_URL;
var CLOUD_NAME = 'guesty';
exports.CLOUD_NAME = CLOUD_NAME;
var CLOUDINARY_API_KEY = 389841923615526;
exports.CLOUDINARY_API_KEY = CLOUDINARY_API_KEY;